const styles = {
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '27px',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
    },
    tooltipLabel: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#8697AB',
    },
    tooltipValue: {
        fontFamily: 'Silka_Bold',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#4D5C71',
    },
    card: {
        borderColor: '#F7F8FC',
        borderWidth: '1',
        borderRadius: '8px',
        textAlign: 'center',
    },
    graph: {
        padding: '24px',
        borderRadius: '16px',
    },
    graphMargins: {
        top: 32,
        right: 24,
        left: 0,
        bottom: 0,
    },
};
export default styles;
